/**
 * Simple bot detection utility.
 * - On client: checks navigator.webdriver and common bot/crawler user agents.
 * - On server: pass the request user agent string as parameter.
 */
export const isBot = (userAgentOverride?: string): boolean => {
  try {
    const ua = (userAgentOverride
      || (typeof navigator !== 'undefined' ? navigator.userAgent : '')
      || '').toLowerCase();

    // Common automation flags (only on client)
    // Note: navigator.webdriver is true for headless browsers and automation
    if (typeof navigator !== 'undefined') {
      const nav = navigator as Navigator & { webdriver?: boolean };
      if (typeof nav.webdriver === 'boolean' && nav.webdriver) return true;
    }

    if (!ua) return false;

    // Common bot and crawler signatures
    const botPatterns = [
      'bot',
      'crawler',
      'spider',
      'crawling',
      'headless',
      'phantomjs',
      'slurp',
      'bingbot',
      'adsbot',
      'googlebot',
      'duckduckbot',
      'baiduspider',
      'yandexbot',
      'sogou',
      'exabot',
      'facebot',
      'facebookexternalhit',
      'ia_archiver',
      'semrushbot',
      'petalbot',
      'ahrefsbot',
      'mj12bot',
      'curl',
      'wget',
      'uptimerobot',
      'linkchecker',
      'python-requests',
    ];

    return botPatterns.some((pattern) => ua.includes(pattern));
  } catch {
    return false;
  }
};
